import { ServerOrderApi } from "./orderApi";

import * as opsApi from "./opsApi";

export const orderApi = new ServerOrderApi();

export { opsApi };
